import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function CandlestickTileChartHelp() {
    return (
        <IconTooltip>
            <div>
                A Candlestick chart illustrates four price points: Open, Close,
                High, and Low, over a specified time period.
                <br /> <br />
                The Candlestick body represents the price difference between the
                open and close during the time window. When red, the close was
                lower than the open. When green, the close was higher than the
                open. The upper shadow indicates the high point, and the bottom
                shadow indicates the low.
                <br /> <br />A Candlestick Capsule can be configured by
                selecting a symbol from your portfolio or adding it in settings,
                and setting the time range.
                <br /> <br />
                You can also view precise values for a Candlestick by “flipping”
                the Capsule (click on a Candlestick).
            </div>
        </IconTooltip>
    );
}
